import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import catalogReducer from '../features/catalog/catalogSlice';
import productDetailsReducer from '../features/productDetails/productDetailsSlice';
import selectionReducer from '../features/selection/selectionSlice';
import sessionReducer from '../features/sessions/sessionSlice';
import globalReducer from '../features/global/globalSlice';
import boutiqueReducer from '../features/dashboard/boutiqueSlice';
import logosReducer from '../features/logos/logosSlice';
import productionReducer from '../features/admin/production/productionSlice';
import logsReducer from '../features/admin/logs/logsSlice';

export const store = configureStore({
  reducer: {
    global: globalReducer,
    session: sessionReducer,
    catalog: catalogReducer,
    product_details: productDetailsReducer,
    selection: selectionReducer,
    boutique: boutiqueReducer,
    logos: logosReducer,
    production: productionReducer,
    logs: logsReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
